export const ParameterDirection = {"Input":1,"Output":2,"InputOutput":3}
 